// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Wp-z","breadcrumbForward":"Xp-z","breadcrumbBack":"Yp-z","selected":"Zp-z"};